import { generateUniqueKey, getServiceComponent } from '@/utils'

import componentNotFound from '@/components/misc/componentNotFound'

export default function(h) {
  try {
    return h(
      getServiceComponent(`${this.service}/item`),
      {
        props: { value: this.value },
        key: generateUniqueKey(),
        on: {
          remove: event => {
            this.$emit('remove', event)
          }
        }
      }
    )
  } catch (error) {
    return h(componentNotFound)
  }
}
